import React from 'react';
import ExcerptHero from '../components/excerpt/ExcerptHero';
import ExcerptNote from '../components/excerpt/ExcerptNote';
import ExcerptText from '../components/excerpt/ExcerptText';
import ExcerptCta from '../components/excerpt/ExcerptCta';

const ExcerptPage = () => (
  <main>
    <ExcerptHero />
    <ExcerptNote />
    <ExcerptText />
    <ExcerptCta />
  </main>
);

export default ExcerptPage;